import { Card, CardContent, CardHeader, FormControl, Select, TextField, Button, Divider, CircularProgress, InputLabel, CardActions } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Alert from 'src/components/Alert';
import { makeStyles } from '@material-ui/styles';
import SendIcon from '@material-ui/icons/Send';
import React, { useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { getUser } from 'src/utils/Common'
import axios from 'src/utils/axios'
import DigiportIssues from 'src/components/DigiportIssues'

const useStyles = makeStyles((theme) => ({
  root: {},
  kategoriFlex: {
    margin: theme.spacing(0),
    display: 'flex',
  },
  fieldsDigi: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },

}));

const types = [
  { id: 0, name: 'Sorun ile alakalı başlığı seçiniz!..', malzeme: false },
  { id: 10, name: 'Ürün Problemi/Arızası', malzeme: false },
  { id: 11, name: 'Dökümantasyon Hatası/Eksikliği', malzeme: false },
  { id: 12, name: 'Ürün Manusoftta Tanımlı Değil', malzeme: false },
  { id: 13, name: 'Ürün Geliştirme Önerileri', malzeme: false },
  { id: 14, name: 'işçilik/Hizmet Kodları ', malzeme: false },
  { id: 15, name: 'Malzeme Fiyatı Tanımsız', malzeme: true },
  { id: 16, name: 'Malzeme Fiyat Doğruluğu Kontrol', malzeme: true },
  { id: 17, name: 'Referans Numarası Malzeme Listesinde Yok', malzeme: false },
  { id: 18, name: 'Ürün Altında Malzeme Tanımlı Değil', malzeme: false },
  { id: 19, name: 'Ürün Altında Malzeme Listesi Mevcut Değil', malzeme: false },
  { id: 22, name: 'Patlatılmış Resim Hatalı / Eksik', malzeme: false },
  { id: 23, name: 'Malzeme Tanımı / Açıklaması değişimi', malzeme: true },
  { id: 24, name: 'Malzeme Ambalaj / Etiket Hatası', malzeme: true },
  { id: 25, name: 'Üründe Kullanılan Malzeme Adedi Kontrol', malzeme: true },
  { id: 26, name: 'Malzeme Referans Numarası Hatalı', malzeme: true },
  { id: 29, name: 'Malzeme Ambalaj Adedi Eksik / Fazla', malzeme: true },
  { id: 30, name: 'Malzeme Farklı / Hatalı', malzeme: true },
  { id: 32, name: 'Malzeme Fotoğrafı Eksik', malzeme: true },
  { id: 33, name: 'Malzeme Boyut Bilgisi', malzeme: true },
  { id: 34, name: 'Malzeme Bülteni Eksik / Hatalı', malzeme: true },
  { id: 36, name: 'Hasarlı Malzeme', malzeme: true },
  { id: 37, name: 'Eksik Adet / Gönderi', malzeme: true },
  { id: 57, name: 'Ürün e-Kütüphanede Tanımlı Değil', malzeme: false },
];

function Digiport({ readonly, FisNo, tasks, materialReducer }) {

  const classes = useStyles();
  const [uyariOpen, setUyariOpen] = useState(false);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyariTip, setUyariTip] = useState('success');

  const [kategori, setKategori] = useState(0);
  const [aciklama, setAciklama] = useState('');
  const [malzeme, setMalzeme] = useState(false);
  const [malzemeValue, setMalzemeValue] = useState({});

  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingGonder, setLoadingGonder] = useState(false);


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyariOpen(false);
  };

  const showAlert = (tip, msg) => {
    setUyariAciklama(msg);
    setUyariTip(tip);
    setUyariOpen(true);
  }

  const handleGonder = () => {
    if (kategori === 0) {
      showAlert('error', 'Kategori Seçimi Yapınız!..');
      return;
    }
    if (aciklama.length === 0) {
      showAlert('error', 'Açıklama Yazınız!..');
      return;
    }
    let data = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();

    if (!readonly && (!data || data.length === 0)) {
      const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
      if (current) {
        saveBaslandiJob(current);
        data = loadBaslandiJob();
      }
    }


    if (data.length === 0) {
      showAlert('error', 'Fiş No bulunamadı!..');
      return;
    }
    if (data[0]?.KUL_MODEL_KODU === undefined || data[0]?.KUL_MODEL_KODU === null || data[0]?.KUL_MODEL_KODU.length === 0) {
      showAlert('error', 'Ürün Seçimi Yapınız!..');
      return;
    }
    if (malzeme && !malzemeValue.MaterialCode) {
      showAlert('error', 'Malzeme Seçimi Yapınız!..');
      return;
    }
    setLoadingGonder(true);
    const user = getUser();

    if (!user?.UserId) {
      return;
    }


    const konu = types.filter(t => parseInt(t.id) === parseInt(kategori))[0]?.name;
    if (!konu) {
      return;
    }

    // Safely access data array
    const firstData = Array.isArray(data) && data.length > 0 ? data[0] : {};

    let body = {
      "serviceDeskId": "1",
      "requestTypeId": kategori,
      "requestFieldValues": {
        "summary": konu || '',
        "description": aciklama || '',
        "customfield_11405": String(firstData?.FisNo || ''),
        "customfield_11489": String(firstData?.SERINO || ''),
        "customfield_12508": String(firstData?.KUL_MODEL_KODU || ''),
      },

      "raiseOnBehalfOf": user.UserId || ''
    }

    if (malzeme) {
      body = { ...body, requestFieldValues: { ...body.requestFieldValues, "customfield_12356": String(malzemeValue?.MaterialCode) } }
    }


    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios.post('/SetArtemisDigiport', body, config)
      .then(response => {
        if (response.data !== "" && response.data.issueId && response.data.issueKey) {
          showAlert('success', `Sorununuz başarıyla iletildi. ${response.data.issueKey} no'lu kayıt oluşturuldu.`);
          setKategori(0);
          setAciklama('');
        } else {
          showAlert('error', 'Bir hata oluştu: ' + (response.data?.errorMessage || ''));
        }
        fecthTickets();
        setLoadingGonder(false);
      })
      .catch(error => {
        showAlert('error', 'Sorun bildirilirken bir hata oluştu. Lütfen tekrar deneyiniz.');
        setLoadingGonder(false);
        console.warn('Digiport hatası:', error.message);
      });

  }

  const fecthTickets = () => {
    setLoading(true);
    axios.get(`/GetArtemisDigiportSearch`)
      .then(response => {
        setIssues(response.data !== "" && response.data.total && response.data.total > 0 ? response.data.issues : []);
        setLoading(false);
      })
      .catch(error => {
        setIssues([]);
        setLoading(false);
        console.warn('Digiport listesi alınamadı:', error.message);
      });
  }

  const handleChangeKategori = (value) => {
    setKategori(value);
    let type = types.filter(t => t.id === parseInt(value));
    setMalzeme(type[0]?.malzeme);
  }

  React.useEffect(() => {
    fecthTickets();
    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <Card className={classes.root} >
        <CardHeader title={"Sorun Bildir"} />
        <Divider />
        {uyariOpen && <Alert onClose={uyariKapat} open={uyariOpen} message={uyariAciklama || ''} variant={uyariTip} />}
        <CardContent className={classes.content}>
          <div className={classes.fieldsDigi}>
            <FormControl variant="outlined" className={classes.kategoriFlex}>
              <InputLabel disabled={readonly}>Kategori</InputLabel>
              <Select
                native
                onChange={(e) => handleChangeKategori(e.target.value)}
                label="Kategori"
                fullWidth
                value={kategori}
              >
                {types.sort((a, b) => a.name > b.name ? 1 : -1).map(t => {
                  return <option key={t.id} value={t.id}>{t.name}</option>
                })}
              </Select>
            </FormControl>
          </div>
          {malzeme &&
            <div className={classes.fieldsDigi}>
              <FormControl variant="outlined" className={classes.kategoriFlex}>
                <Autocomplete
                  options={materialReducer.Data}
                  getOptionLabel={(option) => option.MaterialCode + ' ' + option?.MaterialDesc}
                  onChange={(event, newValue) => {
                    setMalzemeValue(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} label="Malzeme seçiniz!.." variant="outlined" />}
                />
              </FormControl>
            </div>}
          <div className={classes.fieldsDigi}>
            <FormControl variant="outlined" className={classes.kategoriFlex}>
              <TextField
                label={"Açıklama"}
                multiline
                minRows={4}
                fullWidth
                value={aciklama}
                onChange={(e) => setAciklama(e.target.value)}
                variant="outlined"
              />
            </FormControl>
          </div>
        </CardContent>
        <Divider />
        <CardActions>
          {loadingGonder ? <CircularProgress
            status={'loading'}
            style={{ marginLeft: '50%' }}
          /> :
            <Button
              variant="contained"
              color="secondary"
              onClick={handleGonder}
              fullWidth
              endIcon={<SendIcon>Gonder</SendIcon>}
            >
              {"Gönder"}
            </Button>
          }
        </CardActions>
      </Card>
      <DigiportIssues issues={issues} loading={loading} />
    </div>
  );
}

export default connect(
  state => ({
    tasks: state.tasks1,
    materialReducer: state.materialReducer,
  })
)(Digiport);
